<template>
  <v-app>
    <div id="clickOutside"></div>
    <v-main>
      <!-- <div class="fixed top-0 right-0 mt-2 mr-2 z-50" style="z-index: 5000">
        <v-select
                    top
                    v-model="$i18n.locale"
                    :items="langs"
                    item-text="label"
                    item-value="value"
                    hide-selected
                    outlined
                    dense
                >
                </v-select>
      </div> -->
      

      <div v-if="$route.meta.requiresUnauthenticated || $route.path == '/elimina-profilo'">
        <router-view/>
      </div>
      <div v-else>
        <div v-if="!loader">
          <div v-if="user && !user.registrazioneCompletata" class="d-flex">
            <side-bar></side-bar>
            <div style="width: 100%">
              <div class="notification--container">
                  <the-notifications></the-notifications>
              </div>
              <div class=" px-2 px-sm-3 my-3">
                <div>
                    <transition :name="transitionName" mode="out-in">
                        <router-view/>
                    </transition>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <create-page></create-page>
          </div>
        </div>
        <div v-else class="flex justify-center items-center h-[100vh] w-[100vw]">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </div>
    </v-main>
    <div class="d-none">
      <div>{{cant_action}}</div>
      <div>{{user}}</div>
      <div class="img-200 mr-2 min-h-[200px] relative pointer-events-none"></div>
      <div class="block absolute link-img-m pointer-events-auto"></div>
      <div class="top-0 right-0 w-100 h-100"></div>
      <div class="lg:grid-cols-2"></div>
      <div class="xl:grid-cols-2"></div>
      <div class="grid-cols-1"></div>
      <div class="!border-red"></div>
      <div class="!border-[grey]"></div>
      <div class="!border-[red]"></div>
      <div class="!border-[green]"></div>
      <div class="!border-purple"></div>
      <div class="!border-yellow"></div>
      <div class="!text-red"></div>
      <div class="!text-green"></div>
      <div class="text-blue"></div>
      <div class="text-green"></div>
      <div class="text-[white]"></div>
      <div class="right-3"></div>
      <div class="!text-purple"></div>
      <div class="!text-yellow"></div>
      <div class="bg-red-100"></div>
      <div class="trigger-collapse collapsed"><i class="v-icon"></i></div>
    </div>
  </v-app>
</template>

<script>
  import CreatePage from "./views/CreatePage/CreatePage.vue";
  import SideBar from "./views/SideBar.vue";
  import TheNotifications from "./views/TheNotifications.vue";
  export default {
      components: {
        SideBar,
        TheNotifications,
        CreatePage,
    },
    data(){
      return{
        colSize: 3,
        isAuthenticated: false,
        transitionName: 'opa',
      }
    },
    computed: {
      loader(){
        return this.$store.getters["main_loader"]
      },
      logged(){
        return this.$store.getters["logged"]
      },
      didAutoLogout() {
        return this.$store.getters.did_auto_logout;
      },
      didAutoLogin() {
        return this.$store.getters.isAuthenticated;
      },
      cant_action() {
          let cant_action = this.$store.getters['cant_action']
          return cant_action
      },
      user() {
          let user = this.$store.getters['user/user']
          if(user){
            this.$store.dispatch("cantAction",user)
          }
          return user
      },
    },
    watch: {
      '$route' (to, from) {
        if (from.path === '/associates' || to.path === '/associates') {
          this.transitionName = 'traXR';
        } else {
          this.transitionName = 'traXR';
        }
      },
      didAutoLogout(curValue, oldValue) {
        if (curValue && curValue !== oldValue) {
          this.$router.replace('/login');
        }
      },
      didAutoLogin(curValue, oldValue) {
        this.isAuthenticated = curValue;
        if (!curValue && curValue !== oldValue) {
          this.$router.replace('/login');
        }
      },
    },
    methods:{
      transformSidebar(){
        if(this.colSize == 3){
          this.colSize = 1;
        } else {
          this.colSize = 3;
        }
      }
    },
    async created() {

      // prendi lang dal local storage
      let lang = localStorage.getItem('lang')
      if(lang){
        this.$i18n.locale = lang
      }

    },
  }
</script>

<style lang="scss" >

    .v-main__wrap{
      display: flex;
      flex-direction: column;
      min-height: 100vh;
      & > *:nth-child(2){
        flex-grow: 1;
      }
    }

    .container-allert{
      display: block;
      position: fixed;
      bottom: 10px;
      right: 10px;
      z-index: 100;
    }

    
</style>
